import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'menuFilter', pure: false})

export class MenuFilterPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (args === '') { return value; }

    let query = args.toLowerCase();
    return value.filter(obj =>
      obj.hasOwnProperty('menu') && obj.menu.toLowerCase().indexOf(query) > -1
    );
  }
}
